export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-voronoi/index.js
// module id = ../../../../d3-voronoi/index.js
// module chunks = 3